import { apiClient } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';

export interface LikeToggleRequest {
  targetType: 'feed' | 'comment';
  targetId: string;
  feedId: string;
}

export interface LikeToggleResponse {
  success: boolean;
  message: string;
  data: {
    isLiked: boolean;
    likeChange: number;
    totalLikes: number;
    targetType: string;
    targetId: string;
    userId: string;
  };
}

export interface FeedLikesResponse {
  success: boolean;
  message: string;
  data: {
    feedId: string;
    likesCount: number;
    isMeLiked: boolean;
    likedUsers: Array<{
      _id: string;
      name: string;
      email: string;
      profilePicture?: {
        url: string;
      };
    }>;
    pagination: {
      current: number;
      pages: number;
      total: number;
      limit: number;
    };
  };
}


export const likesService = {
  // Toggle like on feed or comment
  toggleLike: async (data: LikeToggleRequest): Promise<LikeToggleResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.LIKES.TOGGLE, data);
    return response.data;
  },

  // Get likes for a feed
  getFeedLikes: async (
    feedId: string,
    page: number = 1,
    limit: number = 10000000,
    sort: string = '-createdAt'
  ): Promise<FeedLikesResponse> => {
    const url = `${API_ENDPOINTS.LIKES.GET_BY_FEED(feedId)}?page=${page}&limit=${limit}&sort=${sort}`;
    const response = await apiClient.get(url);
    return response.data;
  },


};